/**
 * Stable source identity for matching the same physical checklist card and
 * treatment across mutable taxonomy labels and source snapshot revisions.
 */
export interface ChecklistComparableSource {
  sourceSystem: string;
  sourceTargetId: string;
  sourceItemId: string;
  parallel?: {
    definitionId: string;
  };
}

const BASE_PARALLEL = 'BASE';
const BASE_PARALLEL_ALIASES = new Set([
  '',
  'base',
  'base version',
  'no parallel',
  'no parallel / base version',
]);

export function normalizeChecklistParallelName(value: string | undefined): string {
  const normalized = (value ?? '').trim().toLocaleLowerCase('en-US');
  return BASE_PARALLEL_ALIASES.has(normalized) ? '' : normalized;
}

function keyPart(value: string): string {
  return encodeURIComponent(value.trim());
}

export function checklistComparableKey(
  source: ChecklistComparableSource | null | undefined,
): string | undefined {
  if (
    source === null ||
    source === undefined ||
    typeof source.sourceSystem !== 'string' ||
    typeof source.sourceTargetId !== 'string' ||
    typeof source.sourceItemId !== 'string'
  ) {
    return undefined;
  }
  const sourceSystem = source.sourceSystem.trim();
  const sourceTargetId = source.sourceTargetId.trim();
  const sourceItemId = source.sourceItemId.trim();
  if (sourceSystem === '' || sourceTargetId === '' || sourceItemId === '') return undefined;

  const definitionId =
    source.parallel !== undefined && typeof source.parallel.definitionId === 'string'
      ? source.parallel.definitionId.trim()
      : '';
  return [
    'CHECKLIST',
    keyPart(sourceSystem),
    'TARGET',
    keyPart(sourceTargetId),
    'ITEM',
    keyPart(sourceItemId),
    'PARALLEL',
    keyPart(definitionId === '' ? BASE_PARALLEL : definitionId),
  ].join('#');
}
